import React, { useEffect, useState } from "react";
import { FlaskConical, CheckCircle2, Lightbulb, Ban, FileText } from "lucide-react";
import { sr } from "../../lib/sr";

export default function LifeSciencesTargeting() {
  const [data, setData] = useState(null);
  useEffect(() => {
    sr.lifeSciencesTargeting().then(setData).catch(() => setData({ applies: false }));
  }, []);
  if (!data || !data.applies) return null;

  const downloadSnapshot = async () => {
    try {
      const blob = await sr.complianceSnapshot();
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url; a.download = "compliance-snapshot.pdf"; a.click();
      URL.revokeObjectURL(url);
    } catch { /* ignore */ }
  };

  return (
    <div className="sr-card" data-testid="life-sciences-targeting" style={{ marginTop: 14 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <FlaskConical size={18} color="var(--blue)" />
        <h3 style={{ fontSize: 16, margin: 0 }}>Honest targeting for Peptide &amp; Life Sciences</h3>
      </div>
      <p className="sr-muted" style={{ fontSize: 13, marginTop: 8 }} data-testid="ls-honesty-note">
        {data.honesty_note}
      </p>
      <button className="sr-btn sr-btn-ghost" data-testid="ls-compliance-snapshot" onClick={downloadSnapshot} style={{ marginTop: 4 }}>
        <FileText size={14} /> Compliance Snapshot (PDF)
      </button>

      <div style={{ marginTop: 14 }}>
        <span className="sr-badge sr-badge-green" style={{ fontSize: 10 }}>
          <CheckCircle2 size={12} /> Confirmed available
        </span>
        <div style={{ marginTop: 8 }}>
          {(data.confirmed_available || []).map((c, i) => (
            <div key={i} data-testid={`ls-confirmed-${i}`} style={{ marginBottom: 8 }}>
              <strong style={{ fontSize: 13 }}>{c.label}</strong>{" "}
              <span className="sr-badge sr-badge-gray" style={{ fontSize: 10 }}>{c.type}</span>
              <div className="sr-muted" style={{ fontSize: 12 }}>{c.detail}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: 14 }}>
        <span className="sr-badge sr-badge-amber" style={{ fontSize: 10 }}>
          <Lightbulb size={12} /> Candidate strategies — validate first
        </span>
        <div style={{ marginTop: 8 }}>
          {(data.candidate_strategies || []).map((c, i) => (
            <div key={i} data-testid={`ls-candidate-${i}`} style={{ marginBottom: 10 }}>
              <strong style={{ fontSize: 13 }}>{c.label}</strong>{" "}
              <span className="sr-badge sr-badge-amber" style={{ fontSize: 10 }}>Validate first</span>
              <div className="sr-muted" style={{ fontSize: 12 }}>{c.approach}</div>
              {c.caveat && <div style={{ fontSize: 11, color: "#b45309", marginTop: 2 }}>⚠ {c.caveat}</div>}
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: 14 }}>
        <span className="sr-badge sr-badge-red" style={{ fontSize: 10 }}>
          <Ban size={12} /> What we never do
        </span>
        <ul style={{ margin: "8px 0 0", paddingLeft: 18 }}>
          {(data.prohibited || []).map((p, i) => (
            <li key={i} data-testid={`ls-prohibited-${i}`} className="sr-muted" style={{ fontSize: 12 }}>{p}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}
